/**
 * Riot Sign On (RSO) OAuth2 Configuration
 *
 * To obtain these values, you need an approved production application
 * on the Riot Developer Portal (https://developer.riotgames.com)
 * with an RSO client assigned.
 *
 * - RSO_CLIENT_ID: Your RSO client ID from the Riot Developer Portal
 * - RSO_REDIRECT_URI: Must match exactly what is registered in your RSO client settings
 */

export const RSO_CLIENT_ID = "YOUR_RSO_CLIENT_ID";

export const RSO_REDIRECT_URI = `${window.location.origin}/riot-callback`;

const RSO_AUTH_BASE = "https://auth.riotgames.com/authorize";

/**
 * Builds the full Riot authorization URL.
 * Uses the Authorization Code flow with `openid` scope.
 */
export function buildRsoAuthUrl(): string {
    const params = new URLSearchParams({
        redirect_uri: RSO_REDIRECT_URI,
        client_id: RSO_CLIENT_ID,
        response_type: "code",
        scope: "openid",
    });
    return `${RSO_AUTH_BASE}?${params.toString()}`;
}
